import { OidcClientSettings, User } from "oidc-client-ts";
import AuthProviderProps from "../authProviderProps";
import { useAuth } from "react-oidc-context";

/**
 * Gets the user by localStorage
 * @returns user if exists
 */
export const getUserFromLocalStorage = (): User | undefined => {
  const { authority, client_id } = (AuthProviderProps as OidcClientSettings);

  if (!authority || !client_id) {
    throw Error("Unable to retrieve the access token from local storage. Please, check if the the authority and client_id of the authentication properties.");
  }

  const oidcStorage = localStorage.getItem(`oidc.user:${authority}:${client_id}`);

  return !oidcStorage ? undefined : User.fromStorageString(oidcStorage);
};

/**
 * Gets the access token by the AuthContextProps
 * @returns access token if exists
 */
export const getAccessToken = (): string | undefined => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  return token;
};

/**
 * Gets the access token by localStorage
 * @returns access token if exists
 */
export const getAccessTokenFromLocalStorage = (): string | undefined => {
  const { authority, client_id } = (AuthProviderProps as OidcClientSettings);

  if (!authority || !client_id)
    throw Error(
      "Unable to retrieve the access token from local storage." +
      " Please, check if the the authority and client_id of the authentication properties."
    );

  const oidcStorage = localStorage.getItem(`oidc.user:${authority}:${client_id}`);
  if (!oidcStorage) {
    return undefined;
  }

  return User.fromStorageString(oidcStorage).access_token;
};